/**
 * A client-minted id that works outside a secure context.
 *
 * `crypto.randomUUID` is unavailable on a plain-http origin, so a timestamp
 * plus randomness stands in where the real thing is absent. Callers only
 * need uniqueness within one agency or one browser session.
 */
export function newClientId(prefix: string): string {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
